// react components
import React from 'react'

// data
import {
    reduxModalStateSite,
} from 'data'

// serializers
import {
    CustomCSSProperties,
    FormFieldCustomSerializer,
} from 'serializers/site'

// props
type TemplateBlock797TextAreaSiteProps = {
    blockId: string
    deviceType: 'is-mobile' | 'is-tablet' | 'is-web'
    formInputObj: FormFieldCustomSerializer | undefined
    handleInputChange: (name: string, value: any, label: string, stripe_field_type: string | undefined, stringValue?: string) => void
    isEditHovered: boolean
    reduxModalSite: reduxModalStateSite
    row?: number
    stylesNew: CustomCSSProperties | undefined
    tabIndex: number
    value: string | undefined
}

// main
export const TemplateBlock797TextAreaSite: React.FC<TemplateBlock797TextAreaSiteProps> = React.memo(({
    blockId,
    deviceType,
    formInputObj,
    handleInputChange,
    isEditHovered,
    reduxModalSite,
    row,
    stylesNew,
    tabIndex,
    value,
}) => {
    return (
        <textarea
            id={blockId}
            className={`template-block-797${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
            name={formInputObj?.name}
            onChange={(e) => handleInputChange(formInputObj?.name!, e.target.value, formInputObj?.label!, formInputObj?.stripe_field_type)}
            placeholder={formInputObj?.placeholder === 'true' ? formInputObj?.label : undefined}
            rows={row || 4}
            style={stylesNew}
            // tabIndex={tabIndex}
            value={value}
        />
    )
})
